<template>
    <tr>
        <td>
            <Icon
             v-if="sender.default_sender === '1'"
             icon-class="ui-tag-01" 
             size="5"
             color="green"
             :tooltip="t('settings-connections-common-set_default')"
             />
            <Button
             v-else
             @click.prevent.stop="setAsDefault"
             style="cursor: pointer; background: none; border: none; padding: 0; margin: 0;"
             >
                <Icon
                icon-class="ui-tag-01" 
                size="3"
                color="gray"
                :tooltip="t('settings-connections-common-set_default')"
                style="opacity: 0.5;"
                />
            </Button>
        </td>
        <td @click="$emit('click', sender)">
            <img 
            :src="'/images/senders/'+sender.sender_name+'.png'" 
            :alt="resolvedChannelLabel" 
            class="icon"
            height="20"
            />
            {{ sender.sender_name }}
        </td>
        <td @click="$emit('click', sender)">{{ sender.alias }}</td>
        <td @click="isGlobalAdmin ? null : $emit('click', sender)">
            <span v-if="savingPrice === sender.id">
                <span class="fa fa-spinner fa-spin"></span>
            </span>
            <input
                v-else-if="isGlobalAdmin"
                type="number"
                class="form-control form-control-sm"
                step="0.01"
                min="0"
                style="width: 100px"
                :value="sender.sender_price"
                @change="$emit('update-price', sender, $event.target.value)"
            />
            <span v-else>{{ currencySymbol }} {{ sender.sender_price || $_('settings-connections-common-not_available', null, 'N/A') }}</span>
        </td>
        <td @click="isGlobalAdmin ? null : $emit('click', sender)">
            <span v-if="savingCreditsCost === sender.id">
                <span class="fa fa-spinner fa-spin"></span>
            </span>
            <input
                v-else-if="isGlobalAdmin"
                type="number"
                class="form-control form-control-sm"
                step="0.01"
                min="0"
                style="width: 100px"
                :value="sender.credits_cost"
                @change="$emit('update-credits-cost', sender, $event.target.value)"
            />
            <span v-else>{{ sender.credits_cost }} créditos</span>
        </td>
        <td>
            <span
                class="badge"
                :class="webhookBadgeClass"
                :style="badgeStyle"
                @click.prevent.stop="onWebhookClick"
                :title="webhookTitle"
            >
                {{ webhookLabel }}
            </span>
        </td>
        <td class="text-right">
            <Dropdown
                :options="commands"
                v-model="selectedCommand"
                :placeholder="t('settings-connections-table-actions')"
                style="display:inline-block; min-width:120px; vertical-align:middle;"
            >
                <template #trigger="{ label }">
                    <button class="btn btn-default" type="button" aria-haspopup="true">
                        <span class="far fa fa-ellipsis-v"></span>
                        <span class="ml-2">{{ label }}</span>
                    </button>
                </template>
            </Dropdown>
        </td>
    </tr>
</template>
<script>
import Dropdown from '../../../components/dropdown/dropdown.vue';
import currencyMixin from '../../../mixins/currency-mixin';

export default {
    name: 'sms-row',
    mixins: [currencyMixin],
    components: {
        Dropdown,
    },
    props: {
        sender: {
            type: Object,
            required: true,
        },
        isGlobalAdmin: {
            type: Boolean,
            default: false,
        },
        savingPrice: {
            default: null,
        },
        savingCreditsCost: {
            default: null,
        },
        channelLabel: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedCommand: null,
        };
    },
    computed: {
        resolvedChannelLabel() {
            return this.channelLabel || this.t('settings-connections-channels-sms');
        },
        isWebhookSupported() {
            return this.sender?.webhook_supported !== false && this.sender?.webhook_status !== "unavailable";
        },
        webhookLabel() {
            if (!this.isWebhookSupported) return this.$_('settings-connections-common-not_supported');
            return this.sender?.webhook_status === "success"
                ? this.$_('settings-connections-common-active')
                : this.sender?.webhook_status === "unavailable"
                    ? this.$_('settings-connections-common-unavailable')
                    : this.$_('settings-connections-common-not_configured');
        },
        webhookBadgeClass() {
            if (!this.isWebhookSupported) return "badge-secondary";
            return this.sender?.webhook_status === "success"
                ? "badge-success"
                : this.sender?.webhook_status === "unavailable"
                    ? "badge-secondary"
                    : "badge-warning";
        },
        badgeStyle() {
            return this.isWebhookSupported ? "cursor: pointer;" : "cursor: not-allowed; opacity: 0.8;";
        },
        webhookTitle() {
            if (!this.isWebhookSupported) return this.$_('settings-connections-common-sender_no_webhooks');
            const last = this.sender?.webhook_last_received_at;
            if (this.sender?.webhook_status === "success" && last) {
                return this.$_('settings-connections-common-last_event_received', [last]);
            }
            return this.$_('settings-connections-common-click_view_webhooks');
        },
        commands() {
            if (!this?.sender?.commands) {
                return [];
            }
            return Object.values(this?.sender?.commands)?.map((command) => ({
                label: this.$_(
                    `notifications-senders-commands-${command.command}-title`,
                    null,
                    command.name || command.command,
                ),
                value: command.command,
            })) || [];
        },
    },
    methods: {
        onWebhookClick() {
            if (!this.isWebhookSupported) return;
            this.$emit('open-webhooks', this.sender);
        },
        executeCommand(command) {
            this.$emit('execute-command', command);
        },
        setAsDefault() {
            this.$emit('set-as-default', this.sender);
        },
    },
    watch: {
        selectedCommand: {
            handler() {
                if (this.selectedCommand) {
                    this.executeCommand(this.selectedCommand);
                }
                this.selectedCommand = null;
            },
        },
    },
};
</script>